import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { filterItem } from '@app/cp/shared/models/filterItem';
import { WindowContents } from '@app/cp/shared/enums/windowContents';

@Component({
    selector: 'cp-open-vendor-returns',
    templateUrl: './open-vendor-returns.component.html',
    styleUrls: ['./open-vendor-returns.component.scss'],
    standalone: false
})
export class OpenVendorReturnsComponent implements OnInit {

    constructor(private svc_globals: GlobalsService, private svc_data: DashboardService, private svc_dashWidget: DashboardWidgetService, private el: ElementRef) { }

    @Input() chartType: string = 'donut';
    @Input() inputSearchParams: WidgetSearch;
    @Input() detailsTitleStart: string = '';
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    detailsTitle: string;
    detailsActive: boolean = false;
    selectedFilters: WidgetSearch;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public activeChildComp: number;
    public contentTypes = WindowContents;
    public dashboardQuery: DashboardQueries = DashboardQueries.openVendorReturns;

    widgetQuery: DashboardQueries = DashboardQueries.openVendorReturns;
    chartSearchFilters: widgetFilters[] = [widgetFilters.fiscalYear];

    show: boolean = false;
    searchParam: WidgetSearch;
    data: any;
    gridData: any;

    ngOnInit() {
    }

    search(searchParam: WidgetSearch) {
        this.searchParam = searchParam;
        this.searchParams.emit(searchParam);
        this.searchParam.userId = this.svc_globals.userId;
        this.showSpinner();
        this.svc_data.getDashboardQuery(this.widgetQuery, this.searchParam).subscribe(data => {
            this.data = data;
            this.gridData = data;
            if (data.error) {
                alert('got an error back!');
            }
            this.hideSpinner();
        });
    }

    showSpinner() {
        this.loaderState.emit(true);
    }

    hideSpinner() {
        this.loaderState.emit(false);
    }

    public onToggle(): void {
        this.show = !this.show;
    }

    setDetailData(category?: string) {
        this.showSpinner();
        let filter = new filterItem();
        filter.field = "Status";
        if (category) {
            filter.value = category;
            this.searchParam.out_S = filter.value;
            this.detailsTitle = this.detailsTitleStart + filter.value;
        }
        this.detailsActive = true;
        //this.createComponent(DisplayTarget.bottom, FactoryComponents.Dispatches, this.searchParam);
        //this.chartItemSelected.emit(filter);
        this.selectedFilters = this.searchParam;
        this.windowData.selectedFilters = this.selectedFilters;
        this.windowData.dashboardQuery = this.dashboardQuery;
        if (this.gridData) {
            this.windowData.gridData = this.gridData;
        }
        this.popWindow();

        this.hideSpinner();
    }

    popWindow() {
        this.activeChildComp = this.contentTypes.chartWidget;
        //this.windowData = {};
        this.showWindow = true;
        this.svc_data.disableDragging = true;
    }

    public onGridButtonClick() {
        this.showSpinner();
        this.setDetailData();
    }

    onClosed(e) {
        this.showWindow = false;
        this.svc_data.disableDragging = false;
    }

    public get animate(): any {
        //if (this.enabled) {
        //    return {
        //        type: this.type,
        //        direction: this.direction,
        //        duration: this.duration
        //    };
        //}

        return false;
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }
}
